import React from 'react';
import { styled } from 'styled-components';
import { ShowSearchResult } from './ShowSearchResult';
import { containerPadding } from '../../../components/PlayContainer/PlayContainer';
import { Swipeable } from '../../../components/Swipeable/Swipeable';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShowSearchResultList = ({
  shows,
  searchTerm
}) => {
  const swipeableConfig = [['small', {
    itemCount: 2.3,
    spaceBefore: containerPadding.small,
    spaceBetween: 8
  }], ['medium', {
    itemCount: 3,
    spaceBefore: containerPadding.medium,
    spaceBetween: 24
  }], ['large', {
    itemCount: 4,
    spaceBefore: containerPadding.large,
    spaceBetween: 24
  }], ['xLargeUp', {
    itemCount: 6,
    spaceBefore: 0,
    spaceBetween: 24
  }]];
  return /*#__PURE__*/_jsx(StyledShowSearchResultList, {
    children: /*#__PURE__*/_jsx(Swipeable, {
      config: swipeableConfig,
      buttonPositionFactor: 9 / 16,
      children: shows.map(show => /*#__PURE__*/_jsx(ShowSearchResult, {
        show: show,
        searchTerm: searchTerm
      }, show.id))
    })
  });
};
const StyledShowSearchResultList = styled.section.withConfig({
  displayName: "ShowSearchResultList__StyledShowSearchResultList",
  componentId: "sc-zsnxgi-0"
})(["margin-bottom:20px;"]);